import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const AiPromptsIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/ai-prompts'),
      meta: { permissions: ['administrator'] },
      component: SettingsWrapper,
      props: {
        headerTitle: 'AI_PROMPTS_SETTINGS.TITLE',
        icon: 'i-lucide-sparkles',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'ai_prompts_settings',
          component: AiPromptsIndex,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
  ],
};
